import { useQuery } from "@tanstack/vue-query"
import { axios } from "@/axios"
import { User } from "@/models"

interface IGetUserOptions {
  onSuccess?: (user: User) => void
}

export async function getUser({ onSuccess }: IGetUserOptions = {}) {
  const response = await axios.get("api/me")

  const user = User.fromResponse(response.data.Data)

  if (onSuccess)
    onSuccess(user)

  return user
}

export const GET_USER_KEY = "getUser"

export function useGetUser(options: IGetUserOptions = {}) {
  return useQuery({
    queryKey: [GET_USER_KEY],
    queryFn: () => getUser(options),
    retry: false,
  })
}
